import PropTypes from 'prop-types';

export default {
  clickHandler: PropTypes.func,
  title: PropTypes.string,
  modalKey: PropTypes.string,
};
